// CRITICAL FIX: Import runtime config BEFORE creating axios instance
import { getBackendApiUrl } from './runtime-config';

const BACKEND_API_URL = getBackendApiUrl();

console.log('🚀 Creating Axios with URL:', BACKEND_API_URL);

import axios from 'axios';

// Create main API instance for JSON requests (with default Content-Type)
export const api = axios.create({
  baseURL: BACKEND_API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000
});

// Create separate instance for file uploads - NO default headers!
export const uploadApi = axios.create({
  baseURL: BACKEND_API_URL,
  // Don't set any default headers - let Axios handle Content-Type automatically for FormData
  timeout: 10000
});

// Add interceptor to main API for JSON requests
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add interceptor for upload instance - only sets Authorization, never overwrites Content-Type
uploadApi.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    // Only set Authorization, don't touch Content-Type or any other headers
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Default export for backward compatibility
export default api;
